enum ConnectToAvailableTeamsType {
  Help = "Help",
  FlightPassengers = "FlightPassengers"
}

export default ConnectToAvailableTeamsType;